module.exports = __webpack_public_path__ + "img/public/SiteIcons/listSeaechIcon.svg?c4a917fc";